import { DateTime } from 'luxon';
import { StateRegistrationCitizenship } from 'mutation/constants/state-registration-citizenship';
import { CitizenshipFormVM } from 'mutation/view-models/registration-citizenship';
import { ModelEventoDTO } from 'shell/models/act-category-list';
import { MotArtCitizenship } from 'shell/models/mutation/mot-art-citizenship';
import { ItemVM } from 'shell/view-models/item';

export const transformerNewCitizenshipOpenLegis = (
  modelEventoDTO?: ModelEventoDTO,
  motivoVariazioneCittadinanza?: ItemVM<MotArtCitizenship>
): CitizenshipFormVM | undefined => {
  if (!modelEventoDTO) {
    return;
  }

  return {
    reasonCitizenship: StateRegistrationCitizenship.OpenLegis,
    openLegis: {
      dateForm: modelEventoDTO?.trascrizioneCittadinanza?.dataAccertamento
        ? DateTime.fromISO(modelEventoDTO?.trascrizioneCittadinanza?.dataAccertamento)
        : null,
      article: motivoVariazioneCittadinanza,
    },
  };
};
